// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3 {
  font-size: 1.25rem;
  font-weight: 600;
}

.Participant-Account_custom_card__D6omL,
.Participant-Account_profile_image_card__EmiEW {
  padding-top: 1rem;
  border: 1px solid var(--branded-light-purple);
  border-radius: 10px;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  padding: 1rem;

  h4 {
    font-size: 1rem;
    padding-bottom: 1rem;
    margin: 0;
  }
}

.Participant-Account_profile_image_card__EmiEW {
  padding-top: 1rem;
  display: flex;
  gap: 15px;
}

.Participant-Account_profile_image_content__-SFNh {
  display: flex;
  gap: 15px;
  min-width: fit-content;
}


/* Mobile */
@media (max-width: 768px) {
  .Participant-Account_profile_image_card__EmiEW {
    flex-direction: column;
    align-items: start;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Participant-Account.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;;EAEb;IACE,eAAe;IACf,oBAAoB;IACpB,SAAS;EACX;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;;AAGA,WAAW;AACX;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;EACvB;AACF","sourcesContent":["h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.custom_card,\n.profile_image_card {\n  padding-top: 1rem;\n  border: 1px solid var(--branded-light-purple);\n  border-radius: 10px;\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n  padding: 1rem;\n\n  h4 {\n    font-size: 1rem;\n    padding-bottom: 1rem;\n    margin: 0;\n  }\n}\n\n.profile_image_card {\n  padding-top: 1rem;\n  display: flex;\n  gap: 15px;\n}\n\n.profile_image_content {\n  display: flex;\n  gap: 15px;\n  min-width: fit-content;\n}\n\n\n/* Mobile */\n@media (max-width: 768px) {\n  .profile_image_card {\n    flex-direction: column;\n    align-items: start;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom_card": `Participant-Account_custom_card__D6omL`,
	"profile_image_card": `Participant-Account_profile_image_card__EmiEW`,
	"profile_image_content": `Participant-Account_profile_image_content__-SFNh`
};
export default ___CSS_LOADER_EXPORT___;
